import type { SimInventorySegmentName } from 'types/common';
import { useShallow } from 'zustand/shallow';
import type { SimInventorySelectionState } from './types';
import useSimInventorySelectionStore from './useSimInventorySelectionStore';

const useSimInventorySelected = (segmentName: SimInventorySegmentName) =>
  useSimInventorySelectionStore(
    useShallow((state: SimInventorySelectionState) => state.segmentStates[segmentName].selected)
  );

export default useSimInventorySelected;
